import { useState } from "react";
import { useCookies } from "react-cookie";
import './CookieTracker.css';

var run = false;

function CookieTracker() {
    // eslint-disable-next-line
    const [cookies, setCookie, _removeCookie] = useCookies(['tracker']);
    const [opzionali, setOpzionali] = useState(false);
    const accept = (override = null) => {
        let d = new Date(Date.now())
        d.setDate(d.getDate()+30)
        setCookie('tracker', override === null ? opzionali : override, {path: '/', expires: d });
    }
    if(cookies.tracker === 'false') {
        //attiva analytics senza cookies
        if(!run) {
            const script = document.createElement("script");

            script.text = `window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('consent', 'default', {
                ad_storage: 'denied',
                analytics_storage: 'denied',
                functionality_storage: 'denied',
                personalization_storage: 'denied',
                security_storage: 'denied',
              });
            gtag('js', new Date());
            
            gtag('config', 'G-EZK3NL1ZGY');`

            document.body.appendChild(script);
            run = true;
            
        }
        return <></>
    }
    else if(cookies.tracker === 'true') {
        //attiva analytics
        if(!run) {
            const script = document.createElement("script");

            script.text = `window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            
            gtag('config', 'G-EZK3NL1ZGY');`

            document.body.appendChild(script);
            run = true;
            
        }
        return (
            <>
            </>
        )
    }
    else {
        return (
        <div className="cookie-overlay" onClick={() => accept(false)}>
            <div className="cookie-box" onClick={event => event.stopPropagation()}>          
                <strong>COOKIE POLICY</strong>
                <p>
                    Il nostro sito utilizza i cookies per migliorare l'esperienza di navigazione.
                    Puoi accettare tutti i cookie, selezionarli singolarmente o rifiutarli tutti, cliccando fuori da questo banner rifiuti automaticamente tutti i cookie.
                    La procedura per la gestione e l'eliminazione dei cookie di solito è disponibile nella funzione di aiuto integrata del browser.
                    Per saperne di più sulla nostra <a href="/informativa-cookie.pdf">cookie policy</a> puoi visitare la pagina dedicata in qualsiasi momento.
                </p>
                <div className="cookie">
                    <input type="checkbox" name='cookie-func' checked disabled/>
                    <label htmlFor='cookie-func'>Cookie Obbligatori</label>
                    <p>
                        Questi cookie sono necessari per le funzioni essenziali del sito, come la gestione della sicurezza della rete e la sua accessibilità. I cookie standard non possono essere disattivati.
                    </p>
                </div>
                <div className="cookie">
                    <input type="checkbox" name='cookie-anal' checked={opzionali} onChange={() => setOpzionali(!opzionali)}/>
                    <label htmlFor='cookie-anal'>Cookie di Analisi</label>
                    <p>
                        Questi cookie raccolgono informazioni, come ad esempio il numero di utenti che sta utilizzando il nostro sito o le pagine più visitate, per aiutarci a migliorare l'esperienza dell'utente.
                        La disattivazione di questi cookie comporta l'impossibilità da parte nostra di raccogliere informazioni per migliorare l'esperienza di navigazione.
                    </p>
                </div>
                <div className="controls">
                    <button onClick={() => accept(true)}>Consenti Tutti</button>
                    <button onClick={() => accept()}>Conferma le Mie Scelte</button>
                    <button onClick={() => accept(false)}>Rifiuta Tutti</button>
                </div>
            </div>
        </div>
        )
    }
}

export default CookieTracker